<template>
    <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
        :opacity="detailsOpacity" 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M12.6663 10C12.6663 9.63185 12.9648 9.33337 13.333 9.33337C13.7012 9.33337 13.9997 9.63185 13.9997 10V12C13.9997 13.1046 13.1042 14 11.9997 14H9.99967C9.63148 14 9.33301 13.7016 9.33301 13.3334C9.33301 12.9652 9.63148 12.6667 9.99967 12.6667H11.9997C12.3679 12.6667 12.6663 12.3682 12.6663 12V10Z" 
        :fill="color"/>
        <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M7.33333 12.6667C7.70152 12.6667 8 12.9651 8 13.3333C8 13.7015 7.70152 14 7.33333 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H12C13.1046 2 14 2.89543 14 4V7.33333C14 7.70152 13.7015 8 13.3333 8C12.9651 8 12.6667 7.70152 12.6667 7.33333V4C12.6667 3.63181 12.3682 3.33333 12 3.33333H4C3.63181 3.33333 3.33333 3.63181 3.33333 4V12C3.33333 12.3682 3.63181 12.6667 4 12.6667H7.33333ZM8.89726 8L10.4805 9.58325C10.7283 9.83102 10.7289 10.2334 10.4812 10.4812C10.2334 10.7289 9.83102 10.7283 9.58325 10.4805L8 8.89726L6.41675 10.4805C6.16898 10.7283 5.7666 10.7289 5.51883 10.4812C5.27106 10.2334 5.27172 9.83102 5.5195 9.58325L7.10275 8L5.5195 6.41675C5.27172 6.16898 5.27106 5.7666 5.51883 5.51883C5.7666 5.27106 6.16898 5.27172 6.41675 5.5195L8 7.10275L9.58325 5.5195C9.83102 5.27172 10.2334 5.27106 10.4812 5.51883C10.7289 5.7666 10.7283 6.16898 10.4805 6.41675L8.89726 8Z" 
        :fill="color"/>
    </svg>
</template>
<script>
    export default {
        props:['width','height','color','detailsOpacity'],
    }
</script>

<style scoped>
</style>
